exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".offer-button-box[data-v-14af0072]{position:absolute;right:0}.offers-list[data-v-14af0072]{max-height:250px;height:250px;overflow:scroll;border:1px solid rgba(0,0,0,.17)}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/account/Profile.vue"],"names":[],"mappings":"AACA,mCACE,kBAAmB,AACnB,OAAS,CACV,AACD,8BACE,iBAAkB,AAClB,aAAc,AACd,gBAAiB,AACjB,gCAAmC,CACpC","file":"Profile.vue","sourcesContent":["\n.offer-button-box[data-v-14af0072] {\n  position: absolute;\n  right: 0;\n}\n.offers-list[data-v-14af0072] {\n  max-height: 250px;\n  height: 250px;\n  overflow: scroll;\n  border: solid 1px rgba(0,0,0,0.17);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14af0072","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account/Profile.vue
// module id = 867
// module chunks = 4 5